import axiosInstance from "../instance";

// Get All Categories
const fetchPlatformFee = async () => {
    const response = await axiosInstance.get('/platform-fees');
    return response.data;
}

const addPlatformFee = async (newPlatformFee) => {
    const response = await axiosInstance.post('/platform-fees', newPlatformFee);
    return response.data;
}

const updatePlatformFee = async (newPlatformFee) => {
    const response = await axiosInstance.patch(`/platform-fees/${newPlatformFee.platformFeeId}`, {
        platformFee: newPlatformFee.platformFee
    });
    return response.data;
}

const deletePlatformFee = async (platformFeeId) => {
    const response = await axiosInstance.delete(`/platform-fees/${platformFeeId}`);
    return response.data;
}

export { fetchPlatformFee, addPlatformFee, updatePlatformFee, deletePlatformFee };
